import { AsyncSelectOptions } from 'app/types/select-options';

export const documentTypeOptions: Array<AsyncSelectOptions> = [
  {
    label: 'Bill of Lading',
    value: 'BILL_OF_LADING',
  },
  {
    label: 'Accident Photo',
    value: 'ACCIDENT_PHOTO',
  },
  {
    label: 'Citation',
    value: 'CITATION',
  },
  {
    label: 'Scale Ticket',
    value: 'SCALE_TICKET',
  },
  {
    label: 'PDF',
    value: 'PDF',
  },
  {
    label: 'Invoice',
    value: 'INVOICE',
  },
  {
    label: 'Proof of Correction',
    value: 'PROOF_OF_CORRECTION',
  },
  {
    label: 'Fuel Receipt',
    value: 'FUEL_RECEIPT',
  },
  {
    label: 'Others',
    value: 'OTHERS',
  },
];
